import { render, staticRenderFns } from "./MealItemsFilter.vue?vue&type=template&id=694daf12&scoped=true"
import script from "./MealItemsFilter.vue?vue&type=script&lang=js"
export * from "./MealItemsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694daf12",
  null
  
)

export default component.exports